import { FF_PHARMACIST_ENABLE_SHIPMENTS, FF_PHARMACY_REFERRALS } from './featureFlags';
import type { FeatureFlagKey } from './types';

export interface MenuItem {
  id: number | string;
  name: string;
  link: string;
  // Optional feature flag to be used to conditionally render the menu item (if flag is on, rendered)
  featureFlag?: FeatureFlagKey;
}

export const menus: MenuItem[] = [
  {
    id: 1,
    name: 'ORDERS',
    link: '/orders',
  },
  {
    id: 2,
    name: 'INVENTORY',
    link: '/inventory',
  },
  {
    id: 3,
    name: 'SHIPMENTS',
    link: '/shipments',
    featureFlag: FF_PHARMACIST_ENABLE_SHIPMENTS,
  },
  {
    id: 4,
    name: 'eScript',
    link: '/escript',
    featureFlag: FF_PHARMACY_REFERRALS,
  },
];
